import React from 'react';
// template components
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// image assets
import highResDesktopImageWebp from './images/annuities-hero-desktop.webp';
import highResMobileImageWebp from './images/annuities-hero-mobile.webp';
// styles
import { HeroSectionStyled }from './styles';
// low res images
import { lowResImageDesktop, lowResImageMobile } from './lowResImages';

export default () => {
  return (
    <HeroSectionStyled
      sectionId='income-annuities-hero'
      productName='Annuities'
      headingText={<>Get guaranteed income <WidowBlock>for life.</WidowBlock></>}
      descriptionText={<>Income annuities can help you retire worry free with guaranteed income that will last through retirement, never go down, and that you can never outlive. Think of it like a paycheck for life because it provides a guaranteed income stream.</>}
      ctaPrimary={{
        linkUrl: '/find-a-financial-advisor/',
        buttonText: 'Get started',
        ariaLabel: 'Get annuities with a financial professional.',
        children: '',
      }}
      backgroundImageAriaLabel='A grandmother reading to her granddaughter'
      backgroundImageDesktop={highResDesktopImageWebp.toString()}
      backgroundImageMobile={highResMobileImageWebp.toString()}
      backgroundImageDesktopLowRes={lowResImageDesktop}
      backgroundImageMobileLowRes={lowResImageMobile}
      backgroundVariant='lightB'
      themeType='lightTheme'
    />
  );
};
